module.exports = __webpack_public_path__ + "48d87cb7b60e63b773646038cf4e2500.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img-avocado.png
// module id = 414
// module chunks = 0